import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/services/data.service';

@Component({
  selector: 'app-paymentsuccess',
  templateUrl: './paymentsuccess.component.html',
  styleUrls: ['./paymentsuccess.component.css']
})
export class PaymentsuccessComponent implements OnInit {

  public data;
  constructor(private dataService: DataService) {
    this.data = dataService.getOption();
    console.log('data', this.data);

    if (Object.keys(this.data).length === 0) {
      //this.router.navigateByUrl(`/reservation`);

      this.dataService.setOption('title', 'Mr.');
      this.dataService.setOption('name', 'Rakesh Yadav');
      this.dataService.setOption('email', 'rakesh.kumar@teamcomputers.com');
      this.dataService.setOption('mobile', '8802904146');
      this.dataService.setOption('adult', '2');
      this.dataService.setOption('child', '2');
      this.dataService.setOption('amount', '1000');
      this.dataService.setOption('checkIn', new Date());
      this.dataService.setOption('checkOut', new Date((new Date()).setDate((new Date()).getDate() + 1)));
      this.dataService.setOption('request', 'this is test message to check payment gateway');
      this.dataService.setOption('days', '1');
      this.data = dataService.getOption();
    }

  }

  ngOnInit() {
  }

}
